module.exports = __webpack_public_path__ + "static/forbes-6e88383686e6300dc776021f48b82ba3.png";